export const StyleTimelineStorageKey = 'style-timeline';

export const StyleTimelineColumnStateStorageKey = 'style-timeline-column-state';
